const BcsIcon = () => {
  return (
    <svg viewBox="0 0 30 28.2">
      <path
        d="M1.2,29.762a1.209,1.209,0,0,0-1.2,1.2v25.8a1.208,1.208,0,0,0,1.2,1.2H8.4a1.208,1.208,0,0,0,1.2-1.2v-25.8a1.208,1.208,0,0,0-1.2-1.2Zm9.6,0v1.2h18v21H19.313a.615.615,0,0,0-.244,0H14.513a.615.615,0,0,0-.244,0H10.8v1.2h3v1.2H12.525a1.769,1.769,0,0,0-1.725,1.8v1.8h12v-1.8a1.769,1.769,0,0,0-1.725-1.8H19.8v-1.2h9a1.208,1.208,0,0,0,1.2-1.2v-21a1.208,1.208,0,0,0-1.2-1.2Zm-9.6,1.2H8.4v25.8H1.2Zm9.6,1.2v1.2H26.4v14.4H10.8v1.2H26.4a1.208,1.208,0,0,0,1.2-1.2v-14.4a1.208,1.208,0,0,0-1.2-1.2Zm-6,20.4a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,4.8,52.562Zm10.2.6h3.6v1.2H15Zm-2.475,2.4h8.55a.56.56,0,0,1,.525.6v.6H12v-.6A.559.559,0,0,1,12.525,55.562Z"
        transform="translate(0 -29.762)"
      />
    </svg>
  );
};

export default BcsIcon;
